import React from 'react'
import { Button, useTheme } from '@mui/material'
import { i18WithDefault as t } from '@shared/locales'
import { LoadingButton } from '@mui/lab'

type ContinueButtonProps = {
  loading?: boolean
} & React.ComponentProps<typeof Button>

export const ContinueButton = ({ loading, ...props }: ContinueButtonProps) => {
  const theme = useTheme()

  return (
    <LoadingButton
      variant="contained"
      loading={loading}
      sx={{
        backgroundColor: theme.palette.primary.main,
        '&:hover': { backgroundColor: theme.palette.primary.dark },
        color: theme.palette.getContrastText(theme.palette.primary.main),
      }}
      {...props}
    >
      {t('global.label.continue')}
    </LoadingButton>
  )
}
